/* Import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';
/* Import specific icons */
import {
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleXmark,
  faCommentLines,
  faDownload,
  faEdit,
  faPlus,
  faSignOut,
  faSort,
  faSortDown,
  faSortUp,
  faTimes,
  faTrash,
  faXmark,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faBell,
  faCircleInfo as faCircleInfoSolid,
  faCircleXmark as faCircleXmarkSolid,
  faGear,
  faSitemap,
  faUser,
} from '@fortawesome/pro-solid-svg-icons';

export const loadIcons = () => {
  library.add(
    faXmark,
    faSignOut,
    faUser,
    faCircleInfo,
    faCircleInfoSolid,
    faCircleXmark,
    faCircleXmarkSolid,
    faCircleExclamation,
    faCircleCheck,
    faCommentLines,
    faCircleExclamation,
    faDownload,
    faPlus,
    faSitemap,
    faBell,
    faGear,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faChevronUp,
    faEdit,
    faTrash,
    faTimes,
    faSort,
    faSortDown,
    faSortUp,
  );
};
